/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Metadata_NoneInputs */

const en_transcript_export_metadata_none = /** @type {(inputs: Transcript_Export_Metadata_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No metadata found`)
};

const fr_transcript_export_metadata_none = /** @type {(inputs: Transcript_Export_Metadata_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune metadonnee trouvee`)
};

const de_transcript_export_metadata_none = /** @type {(inputs: Transcript_Export_Metadata_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Metadaten gefunden`)
};

const it_transcript_export_metadata_none = /** @type {(inputs: Transcript_Export_Metadata_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun metadato trovato`)
};

const ru_transcript_export_metadata_none = /** @type {(inputs: Transcript_Export_Metadata_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Метаданные не найдены`)
};

const es_transcript_export_metadata_none = /** @type {(inputs: Transcript_Export_Metadata_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron metadatos`)
};

const zh_cn2_transcript_export_metadata_none = /** @type {(inputs: Transcript_Export_Metadata_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到元数据`)
};

const ja_transcript_export_metadata_none = /** @type {(inputs: Transcript_Export_Metadata_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータが見つかりません`)
};

const hi_transcript_export_metadata_none = /** @type {(inputs: Transcript_Export_Metadata_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई मेटाडेटा नहीं मिला`)
};

const pt_pt2_transcript_export_metadata_none = /** @type {(inputs: Transcript_Export_Metadata_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum metadado encontrado`)
};

/**
* | output |
* | --- |
* | "No metadata found" |
*
* @param {Transcript_Export_Metadata_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_metadata_none = /** @type {((inputs?: Transcript_Export_Metadata_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Metadata_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_metadata_none(inputs)
	if (locale === "de") return de_transcript_export_metadata_none(inputs)
	if (locale === "it") return it_transcript_export_metadata_none(inputs)
	if (locale === "ru") return ru_transcript_export_metadata_none(inputs)
	if (locale === "es") return es_transcript_export_metadata_none(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_metadata_none(inputs)
	if (locale === "ja") return ja_transcript_export_metadata_none(inputs)
	if (locale === "hi") return hi_transcript_export_metadata_none(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_metadata_none(inputs)
	return en_transcript_export_metadata_none(inputs)
});